import React from 'react';

import { Wrapper } from './Block.jsx';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function DividerComponent(props) {
    let wrapperStyle;
    const contentStyle = {
        borderTopColor: '#EAEAEA',
        borderTopStyle: 'solid',
        borderTopWidth: '2px',
        minWidth: '100%',
    };
    const contentContainerStyle = {};
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            Utilities.mapStyleConfigProps(contentStyle, props.blockConfig.block, (propName, propValue) => {
                switch (propName) {
                    case 'backgroundColor':
                        wrapperStyle = { backgroundColor: propValue };
                        return true;
                }
            });
        }

        if (props.blockConfig.layout) {
            Utilities.mapStyleConfigProps(contentContainerStyle, props.blockConfig.layout);
        }
    }
    return (
        <Wrapper {...props} className="mcnDividerBlock" style={wrapperStyle}>
            <td className="mcnDividerBlockInner" valign="top">
                <table
                    align="left"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="mcnDividerContentContainer"
                    style={{ minWidth: '100%' }}
                    width="100%">
                    <tbody>
                        <tr>
                            <td style={contentContainerStyle} valign="top">
                                <table
                                    border="0"
                                    cellPadding="0"
                                    cellSpacing="0"
                                    className="mcnDividerContent"
                                    style={contentStyle}
                                    width="100%">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span></span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    )
}
const DividerTypeConfig = {
    panel: {
        block: function ({ backgroundColor }) {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color',
                        value: backgroundColor
                    },
                    {
                        display: 'Line Color',
                        group,
                        name: 'borderTopColor',
                        type: 'color',
                        value: '#EAEAEA'
                    },
                    {
                        display: 'Line Width',
                        fullWidth: true,
                        group,
                        max: '20',
                        name: 'borderTopWidth',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement-slider',
                        value: { value: '2', unit: 'px' }
                    }
                ]
            }
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '18', unit: 'px' },
                            paddingLeft: { value: '18', unit: 'px' },
                            paddingRight: { value: '18', unit: 'px' },
                            paddingTop: { value: '18', unit: 'px' }
                        }
                    }
                ]
            }
        }
    }
}
const DividerBlockTypeDefinition = (group, { backgroundColor }) => {
    return {
        id: Name.Block.Divider,
        config: {
            block: DividerTypeConfig.panel.block({ backgroundColor }),
            layout: DividerTypeConfig.panel.layout()
        },
        display: 'Divider',
        group,
        image: 'hr.png'
    }
}
const Divider = { BlockTypeDefinition: DividerBlockTypeDefinition, Component: DividerComponent, TypeConfig: DividerTypeConfig };

export default Divider;